import { h } from 'preact'
import { CalculatorSavings } from 'models/apps'
import { formatNumber } from 'utils/format-number'

interface InteractiveElementsProps {
  sellCurrency: string
  buyCurrency: string
  savings: CalculatorSavings
}

const Savings = ({ sellCurrency, buyCurrency, savings }: InteractiveElementsProps) => {
  return (
    <div className="calculator-chart__savings-info">
      <p className="calculator-chart__savings-text">
        Oszczędzasz na wymianie {buyCurrency}
        <span className="calculator-chart__savings-text is-large"> {formatNumber(savings.one_time_saving, 2)} </span>
        <span className="calculator-chart__savings-text is-blue">{sellCurrency} &nbsp; </span>
        jednorazowo
      </p>
      <p className="calculator-chart__savings-text">
        Wymieniając {buyCurrency} co miesiąc oszczędzasz
        <span className="calculator-chart__savings-text is-large"> {formatNumber(savings.yearly_savings, 2)} </span>
        <span className="calculator-chart__savings-text is-blue">{sellCurrency} &nbsp; </span>
        rocznie
      </p>
    </div>
  )
}

export default Savings
